import { useState, useEffect } from "react";
import AddPageWrapper from "../../components/general/AddPageWrapper";
import InputContainer from "../../components/general/InputContainer";
import ReusableCheckbox from "../../components/general/ReusableCheckbox";
import ReusableTextField from "../../components/general/ReusableTextField";
import TitleBar from "../../components/general/TitleBar";
import PaginatedDropDown from "../../components/PaginatedDropDown/PaginatedDropDown";
import SectionSubmitRow from "./SectionSubmitRow";
import { TASK_SECTION, isTaskSectionDirty } from "./taskSectionEdit";

export default function SettingsSection({
  task,
  updateField,
  isReadOnly,
  original,
  isEdit,
  submittingSection,
  onSubmitSection,
}) {
  const [expand, setExpand] = useState(true);
  const [initialTopics, setInitialTopics] = useState([]);
  const [initialTags, setInitialTags] = useState([]);

  useEffect(() => {
    if (!task?.tagDetails) return;
    setInitialTopics(
      task.tagDetails
        .filter((t) => !t.is_tag)
        .map((t) => ({ id: t.id, name: t.name }))
    );
    setInitialTags(
      task.tagDetails
        .filter((t) => t.is_tag)
        .map((t) => ({ id: t.id, name: t.name }))
    );
  }, [task?.tagDetails]);

  const { title, identifier, domains, tags, noTranslationNeeded } = task;

  return (
    <>
      <TitleBar title="Setting" state={expand} setState={setExpand} />
      {expand && (
        <AddPageWrapper>
          <InputContainer
            first
            label="Task Title*"
            field={
              <ReusableTextField
                type="default"
                placeholder="Task Title"
                state={title}
                setState={updateField}
                target="title"
                disabled={isReadOnly}
                grayedOut={isReadOnly}
                borderColor="#000"
                required
                onBlur
                fullWidth
              />
            }
          />
          <InputContainer
            label="Task Identifier*"
            field={
              <ReusableTextField
                type="default"
                placeholder="Task Identifier"
                state={identifier}
                setState={updateField}
                target="identifier"
                disabled={isReadOnly}
                grayedOut={isReadOnly}
                borderColor="#000"
                required
                onBlur
                fullWidth
              />
            }
          />
          <InputContainer
            label="Domain and Topic"
            field={
              <PaginatedDropDown
                apiEndpoint="topics/filter-options"
                multiple
                state={domains}
                setState={updateField}
                target={isReadOnly ? "" : "domains"}
                placeholder="Domain and Topic"
                width={610}
                borderColor="#707070"
                disabled={isReadOnly}
                grayedOut={isReadOnly}
                initialSelectedItems={initialTopics}
              />
            }
          />
          <InputContainer
            label="Tags"
            field={
              <PaginatedDropDown
                apiEndpoint="tag/filter-options"
                multiple
                state={tags}
                setState={updateField}
                target={isReadOnly ? "" : "tags"}
                placeholder="Tags"
                width={610}
                borderColor="#707070"
                disabled={isReadOnly}
                grayedOut={isReadOnly}
                initialSelectedItems={initialTags}
              />
            }
          />
          <InputContainer
            last
            label="No Translation Needed"
            field={
              <ReusableCheckbox
                type="default"
                label="No translation needed"
                fontSize={16}
                state={noTranslationNeeded}
                setState={updateField}
                target="noTranslationNeeded"
                disabled={isReadOnly}
              />
            }
          />
          {isEdit && original && !isReadOnly && (
            <SectionSubmitRow
              disabled={
                !isTaskSectionDirty(original, task, TASK_SECTION.SETTINGS) ||
                submittingSection !== null
              }
              submitting={submittingSection === TASK_SECTION.SETTINGS}
              onSubmit={() => onSubmitSection(TASK_SECTION.SETTINGS)}
            />
          )}
        </AddPageWrapper>
      )}
    </>
  );
}
